import { Switch, Route, Redirect } from 'react-router-dom';
import React from 'react';
import loadRoute from 'launch/components/loadRoute';

const GenericDesign = ({ match, location }) => (
    <Switch>
        <Route
            path={`${match.url}/brief`}
            component={loadRoute(done => require(['launch/components/GenericDesignBrief'], done))}
        />
        <Redirect from="*" to={{ ...location, pathname: `${match.url}/brief` }} />
    </Switch>
);

export default GenericDesign;
